import { render, staticRenderFns } from "./Ransom.vue?vue&type=template&id=9a8bcb88&scoped=true&"
import script from "./Ransom.vue?vue&type=script&lang=js&"
export * from "./Ransom.vue?vue&type=script&lang=js&"
import style0 from "./Ransom.vue?vue&type=style&index=0&id=9a8bcb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8bcb88",
  null
  
)

export default component.exports